import {DUPLICATE_SIDE} from "../constants/constants";

export const duplicateSide = (side, height, length) => {
    return {
        type : DUPLICATE_SIDE,
        payload : {
            side : side,
            height : height,
            length : length
        }
    };
};


// WEBPACK FOOTER //
// ./src/actions/duplicateSide.js